export default __webpack_public_path__ + "static/media/flag-mauritania.b6bfb63b.svg";